import React from 'react';
// @ts-ignore
import styles from './Table.module.scss';
import { ITableCell } from '../../Models/Table/ITableCell';

export default function TableCell(props: ITableCell) {
	const { row, column, style } = props;

	return (
		<div className={styles.flexRow} role='cell' style={style}>
			{column.renderItem ? column.renderItem(row) : row[column.key]}
		</div>
	);
}
